export default defineNuxtRouteMiddleware(async (to) => {
  const tech = useTech()

  to.meta.layout = tech.id || useRoute().meta.layout || 'default'
  // Ensure theme is deterministic based on the destination route.
  // If the route is not tech-scoped, always fall back to the base theme.
  to.meta.theme = to.params.tech
    ? (tech.currentTheme || 'theme-lapiz')
    : 'theme-lapiz'
})
